export default __webpack_public_path__ + "static/media/team106.209f78e0.JPG";